import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { Combo, ComboService } from '../../../services/combo.service';
import {
  ComunicacionControllerService,
  ComunicacionDTO,
  ComunicacionEstadoDTO,
  ComunicacionHistorialControllerService,
  ComunicacionHistorialFilterDTO,
  ComunicacionHistorialPayloadDTO,
  ComunicacionPayloadDTO,
  ComunicacionesCategoriaControllerService,
  ComunicacionesCategoriaDTO,
  ComunicacionesTipoControllerService,
  ComunicacionesTipoDTO,
  ComunicacionesSubcategoriaControllerService,
  ComunicacionesSubcategoriaDTO,
  ComunicacionResponsableDTO,
  DocumControllerService,
  KeycloakUserFilterDTO,
  PageDTOKeycloakUserDTO,
  UserManagementControllerService,
  KeycloakRoleControllerService,
  KeycloakRoleDTO, UserRoleEntityDTO
} from 'api-rest';
import moment from 'moment';
import {DatePipe} from '@angular/common';
import {DownloadService} from '../../../services/download.service';
import {EmpusaAuthenticationService} from '@empusa/empusa-core';
import { ComunicationResponseDialogComponent } from '../comunication-response-dialog/comunication-response-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import swal from 'sweetalert2';


@Component({
  selector: 'comunications-comunication-dialog',
  templateUrl: './comunication-dialog.component.html',
  styleUrls: ['./comunication-dialog.component.scss'],
})
export class ComunicationDialogComponent {
  titulo: String = '';
  comunicacion: ComunicacionDTO;
  soloLectura: boolean;
  datosForm!: FormGroup;
  infoUsuarioForm!: FormGroup;
  estadosForm!: FormGroup;
  otrosForm!: FormGroup;

  tipos!: Combo[];
  estados!: ComunicacionEstadoDTO[];
  categorias!: Combo[];
  categoriasFiltered!: Combo[];
  subcategorias!: Combo[];
  subcategoriasFiltered!: Combo[];
  prioridades!: Combo[];
  responsables!: ComunicacionResponsableDTO[];
  empresas!: any[];
  private categoriasRaw: ComunicacionesCategoriaDTO[] = [];
  private subcategoriasRaw: ComunicacionesSubcategoriaDTO[] = [];
  idEmpresaSeleccionada: number | string | null = null;
  userId: number | null = null;
  adjuntosEstadosBlob: Array<File> = [];
  adjuntosOtrosBlob: Array<File> = [];
  verCambioEstado: boolean = false;
  nueva: boolean = false;
  roles: KeycloakRoleDTO[] = [];

  gridArray: any[] = [];

  headArray: any = [
    {
      Head: 'Fecha',
      FieldName: 'fechaAlta',
      renderValue: (item: any) => this.datePipe.transform(item.fechaAlta, 'dd/MM/yyyy')
    },
    {
      Head: 'Estado',
      FieldName: 'estado',
      Attribute: 'descripcion'
    },
    {
      Head: 'Comentarios',
      FieldName: 'comentarios',
      Tooltip: true,
      Maxtext: 52
    },
    {
      'Head': 'Archivo', 'FieldName': 'actions', 'buttons':
        [
          {
            nameButton: 'donwload',
            icon: 'download',
            toolTip: 'Descargar archivo',
            show: { params: 'canAccessDownload', accion: 'donwload' }
          }
        ], 'width': '8', permanent: true
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle'
        },
      ],
      width: '10.2',
      permanent: true,
    },
  ];


  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ComunicationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService,
    private comboSrv: ComboService,
    private comunicacionHistorialCtrlSrv: ComunicacionHistorialControllerService,
    private datePipe: DatePipe,
    private comunicacionControllerSrv: ComunicacionControllerService,
    private documControllerSrv: DocumControllerService,
    private downloadSrv: DownloadService,
    @Inject('EmpusaAuthenticationService') private authService: EmpusaAuthenticationService | any,
    private userService: UserManagementControllerService,
    private roleService: KeycloakRoleControllerService,
    private dialog: MatDialog,
    private comunicacionesTipoCtrlSrv: ComunicacionesTipoControllerService,
    private comunicacionesCategoriaCtrlSrv: ComunicacionesCategoriaControllerService,
    private comunicacionesSubcategoriaCtrlSrv: ComunicacionesSubcategoriaControllerService,
  ) {
    this.comunicacion = this.data.comunicacion;
    this.soloLectura = this.data.soloLectura;
    this.estados = this.data.estados;

    this.datosForm = this.formBuilder.group({
      tipo: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }],
      fechaCreacion: [{ value: null, disabled: true }],
      fechaModificacion: [{ value: null, disabled: true }],
      prioridad: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }],
      responsable: [{ value: null, disabled: !this.canShowUsuarioEstado() }],
      empresa: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }],
      // La categoría permanece deshabilitada en comunicaciones nuevas hasta que se seleccione la empresa
      categoria: [{ value: null, disabled: this.soloLectura || !this.comunicacion }, { validators: Validators.compose([Validators.required]) }],
      subcategoria: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }],
      fechaIncidencia: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }],
      horaIncidencia: [{ value: null, disabled: this.soloLectura }],
      asunto: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }],
      descripcion: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }],
      contactoPrevio: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }],
    });
    this.infoUsuarioForm = this.formBuilder.group({
      email: [{ value: null, disabled: true }],
      //telefono: [{ value: null, disabled: true }],
      perfil: [{ value: null, disabled: true }]
    });
    this.estadosForm = this.formBuilder.group({
      estado: [{ value: null, disabled: true }],
      comentario: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }],
      nuevoEstado: [{ value: null, disabled: this.soloLectura }, { validators: Validators.compose([Validators.required]) }]
    });
    this.otrosForm = this.formBuilder.group({
      comentariosAdicionales: [{ value: null, disabled: this.soloLectura }]
    });

    if (this.canShowUsuarioEstado()) {
      this.headArray.splice(2, 0,
        {
          Head: 'Usuario',
          FieldName: 'creadoPor'
        });
    }
  }
  ngOnInit(): void {
    this.prioridades = this.comboSrv.getTiposPrioridadesComs();
    this.cargarTipos();
    this.cargarCategorias();
    this.cargarSubcategorias();

    if (this.canShowUsuarioEstado()) {
      this.cargarResponsables();
    }

    if (this.comunicacion) {
      this.titulo = 'Detalle de comunicación – Núm. Registro: ' + this.comunicacion?.id!;
      this.userId = (this.comunicacion?.user as any)?.userId ?? null;
      this.cargarComunicacion();
      this.obtenerUsuario();
      this.deshabilitarCampos();
      this.obtenerHistorialEstados();
    } else {
      this.titulo = 'Nueva comunicación';
      this.nueva = true;
      this.obtenerEmpresasNuevaComunicacion();
      this.mostrarAvisoNuevaComunicacion();
    }

    this.canShowUsuarioEstado();
  }

  deshabilitarCampos(): void {
    this.datosForm.disable();
    this.otrosForm.disable();
    if (this.canShowUsuarioEstado()) {
      this.datosForm.get('responsable')?.enable();
    }
  }

  cargarTipos(): void {
    this.comunicacionesTipoCtrlSrv.findAllComunicacionesTipo().subscribe({
      next: (data) => {
        this.tipos = data.map(tipo => ({ id: tipo.id!, name: tipo.descripcion! }));
      }
    });
  }

  cargarCategorias(): void {
    this.comunicacionesCategoriaCtrlSrv.findAllComunicacionesCategoria().subscribe({
      next: (data) => {
        this.categoriasRaw = data;
        this.categorias = data.map(categoria => ({ id: categoria.id!, name: categoria.descripcion! }));
        // En una nueva comunicación, la categoría no se carga hasta que se seleccione la empresa
        this.categoriasFiltered = this.nueva ? [] : this.categorias;
      }
    });
  }

  cargarSubcategorias(): void {
    this.comunicacionesSubcategoriaCtrlSrv.findAllComunicacionesSubcategoria().subscribe({
      next: (data) => {
        this.subcategoriasRaw = data;
        this.subcategorias = data.map(subcategoria => ({ id: subcategoria.id!, name: subcategoria.descripcion! }));
        this.filtrarSubcategoriasPorCategoria(this.datosForm.get('categoria')?.value, false);
      }
    });
  }

  onChangeCategoria(selectedValue: any): void {
    this.filtrarSubcategoriasPorCategoria(selectedValue.value, true);
  }

  filtrarSubcategoriasPorCategoria(idCategoria: number | null, resetValue: boolean): void {
    this.subcategoriasFiltered = idCategoria
      ? this.subcategoriasRaw
          .filter(subcategoria => subcategoria.categoria?.id === idCategoria)
          .map(subcategoria => ({ id: subcategoria.id!, name: subcategoria.descripcion! }))
      : this.subcategoriasRaw.map(subcategoria => ({ id: subcategoria.id!, name: subcategoria.descripcion! }));
    if (resetValue) {
      this.datosForm.get('subcategoria')?.setValue(null);
    }
  }

  obtenerHistorialEstados(): void {
    let filter: ComunicacionHistorialFilterDTO = {
      comunicacion: { id: [this.comunicacion?.id?.toString()!] }
    }
    this.spinnerSrv.loadingShow();
    this.comunicacionHistorialCtrlSrv.findAllComunicacion(filter, { page: 0, size: 100 })
      .subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.gridArray = this.canAccessAll(response.datos!)
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      })
  }

  obtenerUsuario(): void {
    // Se pide la información del usuario para obtener el perfil
    if (this.comunicacion?.user?.email) {
      const payload: KeycloakUserFilterDTO = { email: [this.comunicacion?.user?.email] };
      this.userService
        .getUsuariosRolesEntity(payload, { page: 0, size: 1 })
        .subscribe({
          next: (respuesta: PageDTOKeycloakUserDTO) => {
            if (respuesta && respuesta?.datos && respuesta?.datos?.length > 0) {
              this.infoUsuarioForm.controls['perfil'].setValue(respuesta?.datos[0]?.activeUserRolesEntitiesDetail);
              this.cargarEmpresas(respuesta?.datos[0]?.userRolesEntities);
            }
          }
        });
    }
  }

  cargarComunicacion() {
    this.datosForm.patchValue({
      tipo: this.comunicacion?.tipo?.id,
      prioridad: this.comunicacion?.prioridad,
      categoria: this.comunicacion?.categoria?.id,
      responsable: this.comunicacion?.responsable?.keycloakId,
      // subcategoria no está tipada en ComunicacionDTO pero el backend la devuelve
      subcategoria: (this.comunicacion as any)?.subcategoria?.id,
      fechaIncidencia: this.comunicacion?.fechaIncidencia,
      horaIncidencia: this.comunicacion?.horaIncidencia,
      asunto: this.comunicacion?.asunto,
      descripcion: this.comunicacion?.descripcion,
      contactoPrevio: this.comunicacion?.contactoSoporte,
      empresa: this.comunicacion?.empresa
    }
    );
    if (this.comunicacion?.fechaModificacion) {
      this.datosForm.controls['fechaModificacion'].setValue(moment(new Date(this.comunicacion?.fechaModificacion)).format('DD/MM/yyyy'));
    }
    if (this.comunicacion?.fechaAlta) {
      this.datosForm.controls['fechaCreacion'].setValue(moment(new Date(this.comunicacion?.fechaAlta)).format('DD/MM/yyyy'));
    }

    this.infoUsuarioForm.patchValue({
      email: this.comunicacion?.user?.email
    });
    this.estadosForm.patchValue({
      estado: this.comunicacion?.estado?.descripcion
    });
    this.otrosForm.patchValue({
      comentariosAdicionales: this.comunicacion?.comentarios,
    });
  }


  cerrar(): void {
    this.dialogRef.close(null);
  }

  guardar(): void {
    this.datosForm.markAllAsTouched();
    this.otrosForm.markAllAsTouched();

    if (this.datosForm.valid && this.otrosForm.valid) {

      let body: ComunicacionPayloadDTO = {
        tipo: this.datosForm.get('tipo')?.value,
        prioridad: this.datosForm.get('prioridad')?.value,
        categoria: this.datosForm.get('categoria')?.value,
        subcategoria: this.datosForm.get('subcategoria')?.value,
        fechaIncidencia: this.datosForm.get('fechaIncidencia')?.value,
        horaIncidencia: this.datosForm.get('horaIncidencia')?.value,
        asunto: this.datosForm.get('asunto')?.value ? this.datosForm.get('asunto')?.value.trim() : null,
        descripcion: this.datosForm.get('descripcion')?.value ? this.datosForm.get('descripcion')?.value.trim() : null,
        comentarios: this.otrosForm.get('comentariosAdicionales')?.value ? this.otrosForm.get('comentariosAdicionales')?.value.trim() : null,
        contactoSoporte: this.datosForm.get('contactoPrevio')?.value,
        empresa: this.datosForm.get('empresa')?.value ? this.datosForm.get('empresa')?.value.trim() : null,
        idEntidad: this.empresas?.find((empresa: any) => empresa.id == this.datosForm.get('empresa')?.value)?.entidadId,
        tipoEntidad: this.empresas?.find((empresa: any) => empresa.id == this.datosForm.get('empresa')?.value)?.role,
        responsable: this.datosForm.get('responsable')?.value ? { keycloakId: this.datosForm.get('responsable')?.value } : undefined
      }

      let adjuntoBlob!: Blob;
      if (this.adjuntosOtrosBlob?.length > 0) {
        adjuntoBlob = this.adjuntosOtrosBlob[0]
      }

      this.spinnerSrv.loadingShow();
      this.comunicacionControllerSrv.createComunicacion1(body, adjuntoBlob)
        .subscribe({
          next: (response) => {
            this.spinnerSrv.loadingHide();
            this.dialogRef.close(true);
            this.snackBarSrv.showSnackBar(
              'La creación de la comunicación se ha realizado correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            let mensaje = 'Ha ocurrido un error al crear la comunicación' + err.error?.cause;
            this.snackBarSrv.showSnackBar(
              mensaje,
              'error'
            );
          },
        })

    } else {
      this.snackBarSrv.showSnackBar(
        'Complete los campos obligatorios',
        'error'
      );
    }

  }

  guardarResponsable(): void {
    if (!this.comunicacion?.id) {
      return;
    }

    const formValue = this.datosForm.getRawValue();
    const idResponsable = formValue.responsable;

    let body: ComunicacionPayloadDTO = {
      tipo: formValue.tipo,
      prioridad: formValue.prioridad,
      categoria: formValue.categoria,
      subcategoria: formValue.subcategoria,
      fechaIncidencia: formValue.fechaIncidencia,
      horaIncidencia: formValue.horaIncidencia,
      asunto: formValue.asunto ? formValue.asunto.trim() : null,
      descripcion: formValue.descripcion ? formValue.descripcion.trim() : null,
      comentarios: this.otrosForm.getRawValue().comentariosAdicionales ? this.otrosForm.getRawValue().comentariosAdicionales.trim() : null,
      contactoSoporte: formValue.contactoPrevio,
      empresa: formValue.empresa ? formValue.empresa.trim() : null,
      // en edición, this.empresas no trae el entidadId real: se usan los valores ya persistidos en la comunicación
      idEntidad: this.comunicacion?.idEntidad,
      tipoEntidad: this.comunicacion?.tipoEntidad,
      responsable: idResponsable ? { keycloakId: idResponsable } : undefined
    }

    this.spinnerSrv.loadingShow();
    this.comunicacionControllerSrv.editByIdComunicacion(this.comunicacion.id, body)
      .subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.comunicacion.responsable = response.responsable;
          this.snackBarSrv.showSnackBar(
            'El responsable se ha guardado correctamente',
            'success'
          );
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al guardar el responsable',
            'error'
          );
        },
      });
  }

  cambiarEstado(): void {
    this.estadosForm.markAllAsTouched();
    if (this.estadosForm.valid) {
      this.estadosForm.get('comentario')?.value;
      this.estadosForm.get('nuevoEstado')?.value;
      let body: ComunicacionHistorialPayloadDTO = {
        comunicacion: { id: this.comunicacion.id },
        estado: this.estadosForm.get('nuevoEstado')?.value,
        comentarios: this.estadosForm.get('comentario')?.value

      }
      let adjuntoBlob!: Blob;
      if (this.adjuntosEstadosBlob?.length > 0) {
        adjuntoBlob = this.adjuntosEstadosBlob[0]
      }

      this.spinnerSrv.loadingShow();
      this.comunicacionHistorialCtrlSrv.createComunicacion(body, adjuntoBlob)
        .subscribe({
          next: (response) => {
            this.spinnerSrv.loadingHide();
            this.dialogRef.close(true);
            this.snackBarSrv.showSnackBar(
              'El cambio de estado se ha realizado correctamente',
              'success'
            );
          },
          error: () => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al realizar el cambio de estado',
              'error'
            );
          },
        });
    }
  }

  controlHasError(form: FormGroup, controlName: string, errorName: string) {
    return (
      form.controls[controlName]?.hasError(errorName) &&
      form.controls[controlName]?.touched
    );
  }

  attachAdjuntoEstado(archivo: File | null): void {
    if (archivo != null) {
      if (archivo.size === 0) {
        this.snackBarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
        this.snackBarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      } else {
        this.adjuntosEstadosBlob.push(archivo);
      }
    }
  }

  detachAdjuntoEstado(archivo: Blob): void {
    this.adjuntosEstadosBlob = this.adjuntosEstadosBlob.filter(
      (adjBlob) => adjBlob !== archivo
    );
  }
  attachAdjuntoOtros(archivo: File | null): void {
    if (archivo != null) this.adjuntosOtrosBlob.push(archivo);
  }
  detachAdjuntoOtros(archivo: Blob): void {
    this.adjuntosOtrosBlob = this.adjuntosOtrosBlob.filter(
      (adjBlob) => adjBlob !== archivo
    );
  }

  action(item: any) {
    if (item.nameButton == 'donwload') {
      this.descargar(item?.documento);

    }else if(item.nameButton == 'view'){
      this.openModalDetalleRespuesta(item);
    }
  }
  toogleEstado() {
    this.verCambioEstado = !this.verCambioEstado;
  }

  //Aparecerá el botón de descargar si el estado tiene un fichero asociado
  canAccessAll(list: any) {
    const listPermission = list.map((objeto: any) => {
      const hayFichero = objeto?.documento?.id ? true : false;
      return {
        ...objeto,
        canAccessDownload: hayFichero
      };
    });
    return listPermission;
  }

  // Descargar fichero de otros datos
  descargar(element: any) {
    this.spinnerSrv.loadingShow();
    this.documControllerSrv.downloadDoc(element.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadSrv.downloadBlob(response, element.nombre);
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al descargar el documento',
          'error'
        );
      },
    });
  }

  isAdmComunicaciones(): boolean {
    return this.authService.hasCurrentUserRole('ADM-COMUNICACIONES');
  }

  obtenerEstados(): Array<ComunicacionEstadoDTO> {
    if (this.isAdmComunicaciones()) {
      const pteUsuario = this.estados.find(x => x.id === 3);
      //ADM-COMUNICACIONES
      let estados = this.estados.filter(x => this.comunicacion?.estado?.id! < x?.id!);
      if (this.comunicacion?.estado?.id === 2 || this.comunicacion?.estado?.id === 4) {
        // Desde "En Curso" o "Pdte Envalora" se puede devolver la comunicación a "Pdte Usuario"
        estados = estados.filter(x => x.id !== 3);
        estados.unshift(pteUsuario!);
      } else if (this.comunicacion?.estado?.id! < 3) {
        estados = estados.filter(x => x.id !== 3);
      }
      return estados;
    } else {
      //USUARIOS FINALES
      if (this.comunicacion?.estado?.id === 3) {
        // Desde "Pdte Usuario" el usuario solo puede pasar a "Pdte Envalora"
        return this.estados.filter(x => x.id === 4);
      }
      return this.estados.filter(x => x.id === 4 || x.id === 5);
    }
  }

  mostrarCambioEstado(): boolean {
    let mostrar = false;
    if (this.isAdmComunicaciones() && (this.comunicacion?.estado?.id !== 3 && this.comunicacion?.estado?.id !== 6)) {
      mostrar = true;
    } if (!this.isAdmComunicaciones() && this.comunicacion?.estado?.id === 3) {
      mostrar = true;
    }
    return mostrar;
  }

  canShowUsuarioEstado(){
    if (this.authService.user?.roleEntities?.length > 0) {
      const  isGestorEnvalora = this.authService.user?.roleEntities.filter((role: any) => role.type === 'GESTOR_ENVALORA').length > 0;
      return isGestorEnvalora;
    }
    return false;
  }

  cargarResponsables(): void {
    this.comunicacionControllerSrv.obtenerResponsables().subscribe({
      next: (responsables) => {
        this.responsables = responsables;
      }
    });
  }

  obtenerEmpresasNuevaComunicacion(){
    const email = this.authService.getCurrentUserMail();
    if (email != null && email != undefined) {
      this.roleService.getRealRoles()
        .subscribe({
          next: (resRoles) => {
            this.roles = resRoles;
            const payload: KeycloakUserFilterDTO = { email: [email] };
            this.userService
              .getUsuariosRolesEntity(payload, { page: 0, size: 1 })
              .subscribe({
                next: (respuesta: PageDTOKeycloakUserDTO) => {
                  if (respuesta && respuesta?.datos && respuesta?.datos?.length > 0) {
                    this.cargarEmpresas(respuesta?.datos[0]?.userRolesEntities);
                    if (this.empresas.length === 1) {
                      this.datosForm.get('empresa')?.setValue(this.empresas[0].id);
                      this.cargarCategoriasPorEmpresa(this.empresas[0].id);
                      this.actualizarIdEmpresaSeleccionada(this.empresas[0].id);
                      this.datosForm.get('categoria')?.enable();
                    }
                  }
                }
              });
          }
        });

    }
  }

  cargarEmpresas(roles: any) {
    let addedIds = new Set<string | number>();
    this.empresas = [];
    if(this.comunicacion){
      if(this.comunicacion.empresa){
        this.empresas.push({id:this.comunicacion.empresa, name: this.comunicacion.empresa, entidadId: this.extraerIdEmpresa(this.comunicacion.empresa)});
        this.actualizarIdEmpresaSeleccionada(this.comunicacion.empresa);
      }
    }else{
      this.comunicacionControllerSrv.obtenerEntidadesAsociadas().subscribe({
        next: (data) => {
          data.forEach((empresa: any) => {
            const idName = empresa.centroPoseedor == null ? `${empresa.tipoUsuario} - ${empresa.razonSocial}`
              : `${empresa.tipoUsuario} - ${empresa.razonSocial} - ${empresa.centroPoseedor}`;
            this.empresas.push({ id: idName, name: idName, role: empresa.tipoUsuario, entidadId: empresa.id });            
          });
        }
      })
    }
    
  }

  extraerIdEmpresa(empresaStr: string | undefined | null): string | null {
    if (!empresaStr) {
      return null;
    }
    const partes = empresaStr.split(' - ');
    return partes.length > 1 ? partes[1] : null;
  }

  onChangeEmpresa(selectedValue: any) {
    if (selectedValue.value) {
      this.cargarCategoriasPorEmpresa(selectedValue.value);
      if (!this.soloLectura) {
        this.datosForm.get('categoria')?.enable();
      }
    }
    this.actualizarIdEmpresaSeleccionada(selectedValue.value);
  }

  actualizarIdEmpresaSeleccionada(idEmpresa: string | number | null): void {
    const empresaSeleccionada = this.empresas?.find((empresa: any) => empresa.id == idEmpresa);
    this.idEmpresaSeleccionada = empresaSeleccionada?.entidadId ?? null;
  }
  cargarCategoriasPorEmpresa(idEmpresa: string) {
    if (this.nueva) {
      this.categoriasFiltered = [];

      const selEmpresa = this.empresas.filter((pEmp: any) => pEmp.id == idEmpresa)[0];
      const roleType = selEmpresa.role;
      const rolesFiltered = this.roles.filter(
        (role) => role?.attributes?.['user_type']?.[0] == roleType
      );

      let pCategorias: string[] = [];

      switch (roleType) {
        case UserRoleEntityDTO.EntityTypeEnum.Adherido:
          pCategorias.push('CAT03');
          if (rolesFiltered.some((item: any) => item.name == "SDDR-CC")) {
            pCategorias.push('CAT05');
          }
          pCategorias.push('CAT02');
          break;
        case UserRoleEntityDTO.EntityTypeEnum.Poseedor:
          pCategorias.push('CAT01');
            pCategorias.push('CAT05');
          pCategorias.push('CAT02');
          break;
        case UserRoleEntityDTO.EntityTypeEnum.GestorEnvalora:
          pCategorias.push('CAT04');

          break;
        case UserRoleEntityDTO.EntityTypeEnum.GestorPoseedor:
          pCategorias.push('CAT04');
          if (rolesFiltered.some((item: any) => item.name == "SDDR-CA")) {
            pCategorias.push('CAT05');
            pCategorias.push('CAT02');
          }
          break;
        case UserRoleEntityDTO.EntityTypeEnum.PuntoRecogida:
          pCategorias.push('PTO_RECOGIDA');
          break;
        case UserRoleEntityDTO.EntityTypeEnum.GestorPuntoRecogida:
          pCategorias.push('CAT04');
          pCategorias.push('PTO_RECOGIDA');
          break;

        case UserRoleEntityDTO.EntityTypeEnum.AcuerdoIndirecto:
          pCategorias.push('AC_GESTORES');
          break;
      }
      this.categoriasFiltered = this.categoriasRaw
        .filter((categoria) => pCategorias.some(filter => categoria.codigo === filter))
        .map(categoria => ({ id: categoria.id!, name: categoria.descripcion! }));

      this.datosForm.get('categoria')?.setValue(null);
      this.filtrarSubcategoriasPorCategoria(null, true);
    } else {
      this.categoriasFiltered = this.categorias;
    }
  }

  mostrarAvisoNuevaComunicacion(): void {
    swal.fire({
      title: 'Aviso importante',
      html: 'Las comunicaciones registradas en este buzón deben referirse exclusivamente a asuntos relacionados con la plataforma ENVANET.<br><br>' +
        'Para consultas generales sobre normativa de envases, por favor escriba a: ' +
        'contacto@envalora.es.',
      icon: 'info',
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false
    });
  }

  openModalDetalleRespuesta(item:any){
    const dialogRef = this.dialog.open(
      ComunicationResponseDialogComponent,
      {
        width: '1050px',
        maxWidth: '95%',
        maxHeight: '70vh',
        data: {
          comunicacion: item,
          displayUsuario: this.canShowUsuarioEstado()
        },
        disableClose: true
      }
    );
  }

}
